import { useToast } from "contexts/ToastContext";
import { useEffect, useRef, useState } from "react";
import { LoadingPageIcon } from "utils/constant";

import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getStakeholder } from "services/getEmployees";
import LegislativeDraftDetail from "./fragments/leftPanel";
import { getLegislativeDrafting } from "services/legislativeService";
import LegislativeDraftRightPanel from "./fragments/rightPanel";
import { useAuth } from "contexts/AuthContext";
import RegistrarLegislativeDraft from "./registrarLegislativeDraft";
import { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";

import { getLegalAdvisories, getLegalAdvisory } from "services/legalAdvisoryService";
import LegalAdvisoryDetail from "./fragments/leftPanel";
import LegalAdvisoryRightPanel from "./fragments/rightPanel";
import { getSectorDirective, getSectorDirectives } from "services/sectorDirectives";
import { getRegisterDirective, getRegisterDirectives } from "services/registerDirectivesService";
import { LEGAL_ADVISORY_REQUEST_STATUS } from "utils/constantValues";

const SingleRegisterDirectives = () => {
    const { showToast } = useToast();
    const { t } = useTranslation();
    const [data, setData] = useState({
        isLoading: true, status: "", forward_status: "",
    });
    const { id } = useParams<{ id: string }>();
    const contextData = useAuth();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getRegisterDirective(contextData.token || contextData?.user?.access_token || "", id || "");
                let user = null;
                if (response.requested_by_id && response.requested_by !== "internal") {
                    try {
                        user = await getStakeholder(response.requested_by_id, contextData.token || contextData?.user?.access_token || "");
                    } catch (err) {
                        console.error(t("FailedToFetchStakeholder"), err);
                        showToast(t("FailedToFetchStakeholder"), "error");
                    }
                }
                setData({
                    isLoading: false,
                    ...response,
                    requested_by_user: user, 
                });
            } catch (error) {
                console.error("Error fetching legal research request:", error);
                showToast("Failed to fetch legal research request.", "error");
                setData((prev) => ({ ...prev, isLoading: false }));
            }
        };

        fetchData();
    }, [id]);

    if (data.isLoading)
        return (
            <div className="flex justify-center items-center h-64">
                {LoadingPageIcon}
            </div>
        );
    if (contextData?.user?.roles?.some((p) => p === "Registrar"))
        return <RegistrarLegislativeDraft request={data} />

    return (
        <div className="flex h-full bg-gray-100 p-2">
            <LegalAdvisoryDetail request={data} />
            <LegalAdvisoryRightPanel request={data} />
        </div>
    );
};

export default SingleRegisterDirectives;
